import { render, staticRenderFns } from "./MultistepSummaryAdditional.vue?vue&type=template&id=5b4fd638"
import script from "./MultistepSummaryAdditional.vue?vue&type=script&lang=js"
export * from "./MultistepSummaryAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports